import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Board from "./components/Board";
import Feature from "./components/Feature";
import Digest from "./components/Digest";
import Faq from "./components/Faq";
import About from "./components/About";
import Join from "./components/Join";
import Footer from "./components/Footer";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 flex items-center justify-center shadow-lg transition-colors"
    >
      <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
    </button>
  );
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Board />
        <Feature />
        <Digest />
        <Faq />
        <About />
        <Join />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}